/**
 * CSRF Protection Utilities
 *
 * This module re-exports from utils/security.ts as the single source of truth.
 * Consumers should use this module for CSRF operations.
 */

import { csrfProtection as securityCsrf } from './security';

// Expose the same API surface that existing consumers expect
export const csrfProtection = {
  generateToken: securityCsrf.generateToken.bind(securityCsrf),

  setCSRFCookie(): string {
    return securityCsrf.setupToken();
  },

  getCSRFCookie(): string | null {
    return securityCsrf.getToken();
  },

  attachToForm: securityCsrf.attachToForm.bind(securityCsrf),

  attachToRequest(init?: RequestInit): RequestInit {
    const headers = new Headers(init?.headers || {});
    const tokenHeader = securityCsrf.getTokenHeader();
    for (const [key, value] of Object.entries(tokenHeader)) {
      headers.set(key, value);
    }
    return { ...init, headers };
  },

  validateToken: securityCsrf.validateToken.bind(securityCsrf),
};
